import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-field-text-area',
  templateUrl: './formly-field-text-area.component.html',
  styleUrls: ['./formly-field-text-area.component.scss']
})
export class FormlyFieldTextAreaComponent extends FieldType
{

}
